import { render, staticRenderFns } from "./createUser.vue?vue&type=template&id=5cad20bf&scoped=true"
import script from "./createUser.vue?vue&type=script&lang=js"
export * from "./createUser.vue?vue&type=script&lang=js"
import style0 from "./createUser.vue?vue&type=style&index=0&id=5cad20bf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cad20bf",
  null
  
)

export default component.exports